'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var reactLaag = require('react-laag');
var reactTransitionGroup = require('react-transition-group');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
var dropdown = require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
var list = require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
var placements = require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var useClickOutside = require('../../../../hooks/use-click-outside.js');
require('../../../../utilities/color.js');
var container = require('../../../../utilities/container.js');
require('date-fns');
require('../../../../utilities/locale.js');
var refs = require('../../../../utilities/refs.js');
var usePrefersReducedMotion = require('../../../../hooks/use-prefers-reduced-motion.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var fadeIn = require('../../../../styles/transitions/fade-in.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('@brandfolder/utilities');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
require('../../../atoms/button/icon-button/icon-button.js');
var standardButton = require('../../../atoms/button/standard-button/standard-button.js');
require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');
var standardList = require('../../../internal/list/standard-list/standard-list.js');
require('../../../internal/listbox/standard-listbox/standard-listbox.js');
require('../../../internal/listitem/standard-listitem/standard-listitem.js');
require('../../../internal/option/standard-option/standard-option.js');
require('../../../internal/textarea/fake-textarea.js');
require('../../../internal/textfield/textfield-addon.js');
require('../../../internal/textfield/textfield-body.js');
require('../../../internal/textfield/textfield-header.js');
require('../../../internal/textfield/textfield-icon.js');
require('../../../internal/textfield/textfield-inner.js');
require('../../../internal/textfield/textfield-wrapper.js');
var baseDropdown = require('../base-dropdown/base-dropdown.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledDropdown = (props)=>{
    const { buttonProps , children , className , closeOnClickAway =true , container: container$1 , containerOffset =0 , id , insidePopout , labels ={} , listItemProps , listItems , listProps , loading , look , onClose , openOnHover =false , placement =placements.Placements.BottomStart , possiblePlacements =[
        placements.Placements.BottomStart,
        placements.Placements.BottomEnd,
        placements.Placements.TopStart,
        placements.Placements.TopEnd
    ] , preventCutoff =true , transitionDelay =0 , transitionDuration =200 , triggerOffset =5 , virtualized =false , ...otherProps } = props;
    const { loaderLabel  } = labels;
    const listId = `${id}-list`;
    const wrapperRef = React.useRef(null);
    const { clickedOutside  } = useClickOutside.useClickOutside({
        ref: wrapperRef
    });
    const nodeRef = React.useRef(null);
    const prefersReducedMotion = usePrefersReducedMotion.usePrefersReducedMotion();
    const [open, setOpen] = React.useState(false);
    const [isOver, hoverProps] = reactLaag.useHover();
    const hasHovered = openOnHover && isOver;
    const isOpen = hasHovered || open;
    React.useEffect(()=>{
        if (insidePopout && clickedOutside && closeOnClickAway) {
            handleToggle(false);
        }
    }, [
        clickedOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const getButtonLook = ()=>{
        switch(look){
            case dropdown.DropdownLooks.Primary:
                {
                    return button.ButtonLooks.Primary;
                }
            default:
                {
                    return button.ButtonLooks.Default;
                }
        }
    };
    const getListLook = ()=>{
        switch(look){
            case dropdown.DropdownLooks.Primary:
                {
                    // TODO: Add more looks
                    return list.ListLooks.Default;
                }
            default:
                {
                    return list.ListLooks.Default;
                }
        }
    };
    const handleOnClose = ()=>{
        if (onClose) onClose();
    };
    const handleToggle = (toggle)=>{
        if (!toggle) {
            handleOnClose();
        }
        setOpen(toggle);
    };
    const onOutsideClick = ()=>{
        if (closeOnClickAway) handleToggle(false);
    };
    const { layerProps , renderLayer , triggerProps  } = reactLaag.useLayer({
        auto: preventCutoff,
        container: container$1 || container.getContainer(id),
        containerOffset,
        isOpen,
        placement,
        possiblePlacements,
        onOutsideClick,
        overflowContainer: true,
        snap: true,
        triggerOffset
    });
    const { ref , style: layerPropsStyle , ...otherLayerProps } = layerProps;
    const timeout = transitionDelay ? transitionDelay + transitionDuration : transitionDuration;
    return /*#__PURE__*/ React__default.default.createElement(baseDropdown.BaseDropdown, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-dropdown__standard': true,
            'bf-dropdown__standard--expanded': isOpen,
            [`bf-dropdown__standard--placement-${placement}`]: placement,
            'bf-dropdown__standard--virtualized': virtualized,
            [`${className}`]: !!className
        }),
        id: id,
        ref: wrapperRef
    }), /*#__PURE__*/ React__default.default.createElement(standardButton.StandardButton, _extends({}, buttonProps, triggerProps, hoverProps, {
        "aria-controls": listId,
        "aria-expanded": isOpen,
        className: classnames__default.default({
            'bf-dropdown__button': true,
            [`${buttonProps?.className}`]: !!buttonProps?.className
        }),
        endIcon: isOpen ? fontIcon.FontIcons.CaretUp : fontIcon.FontIcons.CaretDown,
        look: getButtonLook(),
        onClick: (e)=>{
            handleToggle(!isOpen);
            if (buttonProps?.onClick) {
                buttonProps.onClick(e);
            }
        },
        onKeyUp: (e)=>{
            if (e.key === 'Enter') {
                handleToggle(!isOpen);
            }
            if (buttonProps?.onKeyUp) {
                buttonProps.onKeyUp(e);
            }
        }
    }), children), renderLayer(/*#__PURE__*/ React__default.default.createElement(reactTransitionGroup.Transition, {
        appear: isOpen,
        in: isOpen,
        mountOnEnter: true,
        timeout: timeout,
        unmountOnExit: true
    }, (transitionStatus)=>/*#__PURE__*/ React__default.default.createElement(standardList.StandardList, _extends({}, listProps, hoverProps, otherLayerProps, {
            className: classnames__default.default({
                'bf-dropdown__list': true,
                [`${listProps?.className}`]: !!listProps?.className
            }),
            id: listId,
            labels: {
                loaderLabel
            },
            listItemProps: listItemProps,
            listItems: listItems,
            loading: loading,
            look: getListLook(),
            ref: refs.mergeRefs([
                nodeRef,
                ref
            ]),
            style: {
                ...listProps?.style,
                ...layerPropsStyle,
                ...!prefersReducedMotion && transitionDuration > 0 && fadeIn.transitionFadeIn({
                    transitionDelay,
                    transitionDuration,
                    transitionStatus
                })
            },
            virtualized: virtualized
        })))));
};
const StyledDropdown = styled__default.default(UnstyledDropdown)`
  .bf-button__standard {
    .bf-icon {
      font-size: 12px;
    }
  }

  .bf-list__standard {
    display: none;
  }

  &.bf-dropdown__standard--expanded {
    .bf-list__standard {
      display: block;
    }
  }
`;
/**
 * A dropdown component for showing content within `role="list"` and `role="listitem"`.
 * Suitable content includes links.
 *
 * Required props include `children`, `id`, and `listItems`. It is recommended to set a
 * `width` via CSS class or `style` prop on the `.bf-dropdown__list`, otherwise the `<ul>`
 * width will be as wide as the widest `<li>` elements' content.
 *
 * For dropdowns, `closeOnClickAway` defaults to `true`. Dropdown positioning defaults to
 * `Placements.BottomStart` (left aligned). To right align, set `placement={Placements.BottomEnd}`.
 *
 * Set `loading` and `labels.loaderLabel` to show a `<CircleLoader>` within the dropdown.
 *
 * For list items greater than `10`, set `virtualized` to `true` to window content for
 * better performance.
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/list_role
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listitem_role
 *
 * https://www.w3.org/WAI/ARIA/apg/example-index/disclosure/disclosure-navigation
 *
 * @param props StandardDropdownProps
 * @returns FunctionComponent<StandardDropdownProps>
 */ const StandardDropdown = (props)=>{
    const { look =dropdown.DropdownLooks.Default , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledDropdown, _extends({}, otherProps, {
        look: look
    })));
};

exports.StandardDropdown = StandardDropdown;
//# sourceMappingURL=standard-dropdown.js.map
